import { render, staticRenderFns } from "./PostulacionCambioFecha.vue?vue&type=template&id=7f3afb57"
import script from "./PostulacionCambioFecha.vue?vue&type=script&lang=js"
export * from "./PostulacionCambioFecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports